import { doc, updateDoc, Timestamp } from 'firebase/firestore';
import { db } from '../../config';
import { getResult } from './read';
import { createResultHistory } from './history';
import { ResultHistoryActionType } from '../../../../types/resultHistory';

export interface UpdateAssigneeRequest {
  resultId: string;
  assigneeId: string;
  assigneeName: string;
  assigneeIconUrl: string | null;
  updatedBy: string;
  updatedByName: string;
}

/**
 * resultレコードの担当者を変更（単一）#2642
 */
export const updateAssignee = async ({
  resultId,
  assigneeId,
  assigneeName,
  assigneeIconUrl,
  updatedBy,
  updatedByName,
}: UpdateAssigneeRequest): Promise<void> => {
  const existing = await getResult(resultId);
  if (!existing) {
    throw new Error('更新対象のデータが見つかりません');
  }

  const now = Timestamp.now();
  const updateData = {
    assignee_id: assigneeId,
    assignee_name: assigneeName,
    assignee_icon_url: assigneeIconUrl,
    assignee_set_at: now,
    assignee_set_by: updatedBy,
    updated_at: now,
    updated_by: updatedBy,
  };

  const resultRef = doc(db, 'results', resultId);
  await updateDoc(resultRef, updateData);

  // 履歴記録（失敗してもメイン処理は止めない）
  try {
    await createResultHistory({
      result_id: resultId,
      action_type: ResultHistoryActionType.EDIT,
      changed_fields: {
        assignee_id: assigneeId,
        assignee_name: assigneeName,
        assignee_icon_url: assigneeIconUrl,
      },
      previous_values: {
        assignee_id: existing.assignee_id ?? null,
        assignee_name: existing.assignee_name ?? null,
        assignee_icon_url: existing.assignee_icon_url ?? null,
      },
      user_id: updatedBy,
      user_name: updatedByName,
    });
  } catch {
    // 履歴記録の失敗はメイン処理を止めない
  }
};
